module.exports = __webpack_public_path__ + "static/work16-3e75d982c252acc538dc4023e3cd1a25.jpg";